import JassEnum from './enum';

/**
 * type raritycontrol
 */
export default class JassRarityControl extends JassEnum {}
